

















































































import Vue from 'vue';
import { dialogMaxWidth } from '@/constants';
import { EventBus } from '@/event-bus';
import { Route } from 'vue-router/types/router';

interface Data {
  showConfirmModal: boolean;
  dialogMaxWidth: string;
  closingWrapper: boolean;
}

export default Vue.extend({
  name: 'StepperWrapper',
  props: {
    currentStep: {
      type: [Number, String],
      required: true,
    },
    steps: {
      type: Array as () => any[],
      required: true,
    },
    nonLinear: {
      type: Boolean,
      default: true,
    },
    altLabels: {
    type: Boolean,
    default: false,
    },
    stepsVisible: {
      type: Boolean,
      default: true,
    },
    stepsDisabled: {
      type: Boolean,
      default: false,
    },
    defaultPreviousRoute: {
      type: String,
      default: 'accounts',
    },
    confirmBeforeClose: {
      type: Boolean,
      default: false,
    },
    hasChanges: {
      type: Boolean,
      default: false,
    },
    suppressClose: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    modalTitle: {
      type: Array as () => string[],
      default: () => ['global_title_confirm-close'],
    },
    modalText: {
      type: Array as () => string[],
      default: () => ['global_text_confirm-close'],
    },
    modalActionCancel: {
      type: Array as () => string[],
      default: () => ['global_action_confirm-close_cancel', 'global_no'],
    },
    modalActionConfirm: {
      type: Array as () => string[],
      default: () => ['global_action_confirm-close_confirm', 'global_yes'],
    },
  },
  data(): Data {
    return {
      showConfirmModal: false,
      dialogMaxWidth,
      closingWrapper: false,
    };
  },
  beforeMount() {
    EventBus.$emit('hideSkip');
  },
  beforeDestroy() {
    EventBus.$emit('showSkip');
  },
  mounted() {
    EventBus.$on('closeStepperWrapper', this.closeWrapper);
    this.$nextTick(() => {
      EventBus.$emit('initialLoadDone');
    });
  },
  destroyed() {
    EventBus.$off('closeStepperWrapper');
  },
  methods: {
    triggerCloseAction(): void {
      if (this.confirmBeforeClose && this.hasChanges) {
        this.showConfirmModal = true;
      } else {
        this.closeWrapper();
      }
    },
    closeModal(): void {
      this.showConfirmModal = false;
    },
    closeWrapper(): void {
      this.closingWrapper = true;

      if (this.previousRoute.name) {
        this.$router.push({
          name: this.previousRoute.name,
          params: this.previousRoute.params,
        });
      } else {
        this.$router.push({
          name: this.defaultPreviousRoute,
        });
      }
    },
    setStep(payload): void {
      this.$emit('setStep', payload);
    },
  },
  computed: {
    // TODO fix typings
    previousRoute(): Route {
      return this.$store.getters.previousRoute;
    },
  },
});
